import {FC, useEffect, useMemo, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import ReactSelect from 'react-select'
import {getRoute} from 'src/api/modules/getdatalist'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {setSoItem, soSelector} from 'src/redux/slices/soSlices'
import {TIncontermCode, disableRouteByIncoterm} from 'src/utils/disableRouteByIncoterm'
import swal from 'sweetalert'

type TOption = {value: string; label: string; route_desc: string}

interface Props {}

export const SelectRoute: FC<Props> = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {orderItem, soItem} = useAppSelector(soSelector)

  const [options, setOptions] = useState<TOption[]>([])
  const [selected, setSelected] = useState<TOption | null>(null)

  /** @deprecated */
  const incotermCode = useMemo(() => {
    if (!orderItem) return ''
    if (!orderItem?.incoterm1) return ''
    return orderItem.incoterm1.code as TIncontermCode
  }, [orderItem])

  const handleSelected = (option: TOption | null) => {
    setSelected(option)
    if (option) {
      const {value: route, route_desc} = option
      dispatch(setSoItem({...soItem, route, route_desc}))
    }
  }

  useEffect(() => {
    if (!orderItem) return
    if (!orderItem?.order_sub_detail) return
    if (!orderItem?.order_sub_detail?.sales_org_code) return

    const salesOrg = orderItem?.order_sub_detail?.sales_org_code
    const getroutedata = async (salesOrg: string) => {
      try {
        const res = await getRoute(salesOrg)

        setOptions(
          res.data.data.map((item: any) => {
            return {
              value: item.route,
              label: `${item.route}-${item.route_desc}`,
              route_desc: item.route_desc,
            }
          })
        )
      } catch (error: any) {
        const text = error?.message ?? 'Failed to fetch route data'
        swal({title: 'Error', text})
        setOptions([])
      }
    }
    getroutedata(salesOrg)
  }, [])

  if (!orderItem) return null

  return (
    <Row className='mb-3'>
      <Col md={4}>
        <Form.Label className='mt-3'>{t('Route')}</Form.Label>
      </Col>
      <Col md={8}>
        <ReactSelect
          placeholder={t('pilih')}
          options={options}
          value={selected}
          isDisabled={disableRouteByIncoterm(incotermCode as TIncontermCode)}
          onChange={(option: any) => handleSelected(option as TOption | null)}
        />
      </Col>
    </Row>
  )
}
